import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { useEffect, useState, useRef } from "react";
import { Config } from "../../config/config";
import {
  fetchBrands,
  fetchAgencies,
  fetchAssociations,
} from "../../utils/requests";
import ReactMarkdown from "react-markdown";
import {
  useSectionVisibility,
  useScrollContext,
} from "../../utils/ScrollContext";

const WeWork = ({ textes, type, setIsBackgroundWhite, isBackgroundWhite }) => {
  const [data, setData] = useState([]);
  const { ref: sectionRef } = useSectionVisibility(`wework-${type}`, 0.3);
  const { getVisibleSections } = useScrollContext();
  const targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end end"],
  });

  const getDatas = () => {
    const lowerType = type;

    switch (lowerType) {
      case "brands":
        fetchBrands().then((data) => setData(data.data));
        break;
      case "agencies":
        fetchAgencies().then((data) => setData(data.data));
        break;
      case "associations":
        fetchAssociations().then((data) => setData(data.data));
        break;
      default:
        return "";
    }
  };

  useEffect(() => {
    getDatas();
  }, []);

  const logos = data.map((item) => ({
    id: item.id,
    alt: item.attributes.name,
    src:
      Config.api.mediaUrl +
      item.attributes.logo.data.attributes.formats.thumbnail.url,
  }));

  useMotionValueEvent(scrollYProgress, "change", (value) => {
    if (value > 0.2) {
      setBgWhite(value);
    } else if (value === 0.9) {
      setBgWhite(value);
    }
  });

  const setBgWhite = (value) => {
    const visibleSections = getVisibleSections();
    if (visibleSections.length === 1 && visibleSections.includes("wework-brands")) {
      if (value > 0.74) {
        setIsBackgroundWhite(true);
      } else if (value < 0.72) {
        setIsBackgroundWhite(false);
      }
    }
    if (visibleSections.length === 1 && visibleSections.includes("wework-associations")) {
      if (value > 0) {
        setIsBackgroundWhite(true);
      } else if (value === 1) {
        setIsBackgroundWhite(false);
      }
    }
    if (visibleSections.length === 1 && visibleSections.includes("wework-agencies")) {
       if (value > 0) {
        setIsBackgroundWhite(true);
      } else if (value === 1) {
        setIsBackgroundWhite(false);
      }
    }
  };

  return (
    logos.length > 0 && (
      <motion.div
        animate={{
          backgroundColor: "#ffffff", // This will work
        }}
        className="w-screen h-screen flex flex-col wework-container justify-center items-center"
        ref={(ref) => {
          sectionRef(ref);
          targetRef.current = ref;
        }}
      >
        <div className="max-w-[1440px]">
          {/* <h1 className="text-4xl font-bold mb-8 text-white">We work with {type.type}</h1> */}
          <div className="text-8xl text-left font-bold text-black pt-[5vh] font-lexend font-semibold text-[clamp(24px,4vw,55pt)] relative ml-[5%] mr-[5%] before:content-[''] before:absolute before:bottom-[-15px] before:left-0 before:h-2.5 before:w-4/5 before:border-b-4 before:border-black after:content-[''] after:absolute after:top-[96.5%] after:right-[21%] after:w-2 after:h-12 after:bg-black">
            <ReactMarkdown
              escapeHtml={false}
              components={{
                strong: ({ node, ...props }) => (
                  <span className="centered-text-strong" {...props} />
                ),
              }}
            >
              {(type === "brands" && textes?.weworkBrands) ||
                (type === "agencies" && textes?.weworkAgencies) ||
                (type === "associations" && textes?.weworkAssociations)}
            </ReactMarkdown>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3 sm:gap-4 lg:gap-5 p-2.5 w-auto h-auto relative max-h-[60vh] m-[2vw] overflow-y-auto">
            {logos.map((logo) => (
              <motion.img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className={`w-50 h-50 mg-0 pd-0 invert`}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              />
            ))}
          </div>
        </div>
      </motion.div>
    )
  );
};

export default WeWork;
